import { memo } from 'react';
import { Flex } from '@chakra-ui/react';

import PlanToggleSquareButton from './PlanToggleSquareButton';

export const PLAN_TIME_FILTERS = ['M', 'Q', 'Y'] as const;
export type PlanTimeFilterValue = typeof PLAN_TIME_FILTERS[number];

interface Properties {
  value: PlanTimeFilterValue;
  onChange: (value: PlanTimeFilterValue) => void;
  variant?: 'default' | 'tableTime';
}

const PlanTimeFilterSegment = ({ value, onChange, variant = 'default' }: Properties) => {
  return (
    <Flex alignItems='center' gap={variant === 'tableTime' ? 3 : 2} flexShrink={0}>
      {PLAN_TIME_FILTERS.map((filterKey) => (
        <PlanToggleSquareButton
          key={filterKey}
          isActive={value === filterKey}
          label={filterKey}
          variant={variant}
          onClick={() => onChange(filterKey)}
        />
      ))}
    </Flex>
  );
};

export default memo(PlanTimeFilterSegment);
